import { put } from 'redux-saga/effects';
import EasyRedux from '../../utils/EasyRedux';
import handleSagaError from '../handleSagaError';

const key = 'FILTERS/ALL';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetFilters(client, { payload: { si, resolve, reject } }) {
  try {
    const response = yield client.post('/service/filters', {
      data: { si },
    });
    yield put(actions.loadSuccess(response.result.filters));
    yield resolve && resolve(response.result.filters);
  } catch (e) {
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
    yield reject && reject(e);
  }
}

export default reducer;
